<script>
export default {
  data () {
    return {
      freqVolData: {},
      interval: null,
      lastTs: 0,
      commandInterval: null
    }
  },
  computed: {
    u_level () {
      if (this.freqVolData && this.freqVolData.rms_refer > 1000) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    '$store.state.highSpdMode' () {
      this.pollCommand()
    }
  },
  mounted () {
    this.updateData()
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.$api.getTs({
          collection: 'meter_stable_data',
          sn: this.$store.state.sn
        }).then((res) => {
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg)
            return
          }
          if (this.lastTs !== res.data.data.ts) {
            this.lastTs = res.data.data.ts
            this.updateData()
          }
        })
      }, 1000)
    }
    this.pollCommand()
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    this.pollStop()
  },
  methods: {
    pollCommand () {
      if (this.$store.state.reqMode === 'udp' || this.$store.state.highSpdMode) {
        this.sendCommand()
        if (!this.commandInterval) {
          this.commandInterval = setInterval(() => {
            this.sendCommand()
          }, 600000)
        }
      } else {
        this.pollStop()
      }
    },
    pollStop () {
      if (this.commandInterval) {
        clearInterval(this.commandInterval)
        this.commandInterval = null
      }
    },
    sendCommand () {
      this.$api.command({
        sn: this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        lists: [[1, 6, 0]]
      }).then(res => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
        }
      })
    },
    async updateData () {
      const params = {
        'collection': 'meter_stable_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'fields': ['ua_rms', 'ub_rms', 'uc_rms', 'rms_refer', 'freq_refer', 'delt_ua', 'delt_ub', 'delt_uc', 'freq_a', 'freq_b', 'freq_c', 'delt_freqa', 'delt_freqb', 'delt_freqc']
      }
      const {data: res} = await this.$api.queryLastData(params)
      console.log(res)
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      this.freqVolData = res.data
      // console.log(res.data)
    }
  }
}
</script>

<template>
  <div class="pg">
    <!--      电度计量-->
    <div class="dataItems">
      <div class="title">频率和电压波动</div>
      <div class="dataItem">
        <div class="dataName">
          <div class="dataTitle"></div>
          <div class="dataNvItem">{{ u_level?'电压(kV)':'电压(V)' }}</div>
          <div class="dataNvItem">电压波动(%)</div>
          <div class="dataNvItem">频率(Hz)</div>
          <div class="dataNvItem">频率波动(%)</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">A相</div>
          <div class="dataNvItem">{{ (Number(freqVolData ? freqVolData.ua_rms : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
          <div class="dataNvItem">{{Number(freqVolData ? freqVolData.delt_ua : 0).toFixed(2)}}</div>
          <div class="dataNvItem">{{Number(freqVolData ? freqVolData.freq_a : 0).toFixed(2)}}</div>
          <div class="dataNvItem">{{Number(freqVolData ? freqVolData.delt_freqa : 0).toFixed(2)}}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">B相</div>
          <div class="dataNvItem">{{ (Number(freqVolData ? freqVolData.ub_rms : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
          <div class="dataNvItem">{{Number(freqVolData ? freqVolData.delt_ub : 0).toFixed(2)}}</div>
          <div class="dataNvItem">{{Number(freqVolData ? freqVolData.freq_b : 0).toFixed(2)}}</div>
          <div class="dataNvItem">{{Number(freqVolData ? freqVolData.delt_freqb : 0).toFixed(2)}}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">C相</div>
          <div class="dataNvItem">{{ (Number(freqVolData ? freqVolData.uc_rms : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
          <div class="dataNvItem">{{Number(freqVolData ? freqVolData.delt_uc : 0).toFixed(2)}}</div>
          <div class="dataNvItem">{{Number(freqVolData ? freqVolData.freq_c : 0).toFixed(2)}}</div>
          <div class="dataNvItem">{{Number(freqVolData ? freqVolData.delt_freqc : 0).toFixed(2)}}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">基准值</div>
          <div class="dataNvItem">{{ (Number(freqVolData ? freqVolData.rms_refer : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
          <div class="dataNvItem"></div>
          <div class="dataNvItem">{{ Number(freqVolData ? freqVolData.freq_refer : 0).toFixed(2) }}</div>
          <div class="dataNvItem"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

.pg {
  height: calc(45vh - 50px);
}

.dataValue {
  width: 20%;
}

.dataNvItem {
  height: calc((100% - 70px) / 5);
}
</style>



// WEBPACK FOOTER //
// src/pages/Transient/FreqVolFluctuate/FreqVolFluctuate.vue